export default __webpack_public_path__ + "static/media/client_win.84904f58.jpg";